module.exports = __webpack_public_path__ + "static/media/varais-1.458bcd97.jpg";